export class mdKeyValue{
    key: any;
    value: any;
    constructor(_key?:any, _value?:any)
    {
        this.key = _key;
        this.value = _value;
    }
}